import React from 'react'

import { Loader, ProgressBar } from '@fourthwall/components'

import * as S from './KitSyncJobActive.styled'

type ProgressItem = {
  key: string
  progress: number
  total: number
}

type Props = {
  status: ProgressItem[]
}

export const KitSyncJobActive = ({ status }: Props) => {
  return (
    <S.Container>
      <S.Header>
        <Loader size="small" />
        Syncing with Kit...
      </S.Header>
      <S.StatusList>
        {status.map((item) => {
          const percentage = item.total > 0 ? (item.progress / item.total) * 100 : 0

          const isComplete = percentage === 100
          const isPending = item.total === 0

          return (
            <S.StatusItem key={item.key}>
              <S.StatusLabel>{item.key}</S.StatusLabel>
              <ProgressBar value={item.progress} max={item.total} />
              {isComplete && <S.ProgressText>Completed</S.ProgressText>}
              {isPending && (
                <S.PendingContainer>
                  <Loader size="small" /> pending...
                </S.PendingContainer>
              )}
              {!isComplete && !isPending && (
                <S.ProgressText>
                  {item.progress} of {item.total} synced
                </S.ProgressText>
              )}
            </S.StatusItem>
          )
        })}
      </S.StatusList>
    </S.Container>
  )
}
